import { Helmet } from "react-helmet-async";

export default function Seo({ title, description, path = "", keywords }) {
  const full = title ? `${title} — Désir Events` : "Désir Events — Agence événementielle B2B";
  const url = `https://desir-events.com${path}`;
  return (
    <Helmet>
      <title>{full}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      <meta property="og:title" content={full} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="fr_FR" />
      <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large" />
    </Helmet>
  );
}
